import React from 'react';

import { useTranslation } from 'react-i18next';

import downloadDocument from '../../../../../../../helpers/downloadDocument';

export default function DocumentsList({ documents }) {
  const { t } = useTranslation();

  if (!documents) {
    return null;
  }

  return (
    <div>
      <div className="flex text-sm font-medium mb-1 items-center gap-2">
        {t(
          'AddOrEditPage.AddOrEditLoan.Sections.BorrowerInsurances.Insurance.DocumentsList.Documents'
        )}
      </div>
      <ul className="text-sm p-2 pl-6 list-disc">
        {documents.map((doc) => {
          return (
            <li key={doc.document_id}>
              <button
                type="button"
                className="text-blue-600 underline"
                onClick={() => {
                  downloadDocument(
                    doc.document_id,
                    doc._document?.private_document?.name
                  );
                }}
              >
                {doc._document.type}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
